
import { mergeMap, tap, mapTo } from 'rxjs/operators'
import { Epic } from 'interfaces/middleware'
import { FORM_RECAT_TRANSACTION, FORM_CREATE_SPENDING_TRACKER, FORM_CREATE_INCOME_TRACKER } from 'constants/forms'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { merge, empty, of } from 'rxjs'
import { killFloatingPanesActionCreator, KILL_FLOATING_PANES } from 'actions/floatingPanesActions'
import { combineEpics } from 'redux-observable'
import { destroy } from 'redux-form'
import { DELETE_MONEYFLOW_TRACKER, CHANGE_TRANSACTION_CATEGORY } from 'actions/moneyflowActions'
import { byType } from 'rxOperators/byType'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { formSubmitted } from 'rxOperators/formsLegacy'

const killTrackerPane: Epic = (action$) => {
  const deleteTracker$ = action$
    .pipe(filterRequestOfType(DELETE_MONEYFLOW_TRACKER, 'success'))

  const modifyTracker$ = action$
    .pipe(formSubmitted(
      FORM_CREATE_SPENDING_TRACKER,
      FORM_CREATE_INCOME_TRACKER,
    ))

  return merge(deleteTracker$, modifyTracker$).pipe(
    mapTo(killFloatingPanesActionCreator('tracker')))
}

const killTransactionRecatPane: Epic = (action$, store) => action$
  .pipe(filterRequestOfType(CHANGE_TRANSACTION_CATEGORY, 'success')).pipe(
    mergeMap(() => {
      const { panes } = store.getState().app.floatingPanes
      const recatPane = getItemFromCollection(panes, 'transaction-recat')
      if (!recatPane) {
        return empty()
      }

      return of(
        killFloatingPanesActionCreator(recatPane.type),
      )
    }))

const destroyTransactionsRecatForm: Epic = (action$) => action$
  .pipe(byType(KILL_FLOATING_PANES)).pipe(
    tap(() => {
    // here we are trying to close virtual keyboard on closing floating pane (iOS only). See SM-1208
      try {
        window.focus()
      } catch (e) {}
    }),
    mergeMap(({ payload }) => {
      if (!payload.types.includes('transaction-recat')) {
        return empty()
      }

      return of(destroy(FORM_RECAT_TRANSACTION))
    }))

export const floatingPanesEpic = combineEpics(
  killTrackerPane,
  killTransactionRecatPane,
  destroyTransactionsRecatForm,
)
